<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Registration List" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
				</div>
			</div>
		</div>

		<app-table :id="tableId" :options="options" @action="getListAction" />


		<registration-list-form
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :form-id="formId"
            :data="rowData"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />

		<app-migration-modal
			v-if="migrationConfirmationModalActive"
			:preloader="migrationLoader"
			modal-id="demo-migration"
			@confirmed="confirmedMigration"
			@cancelled="cancelledMigration"
		/>

		<app-delete-modal
			v-if="deleteConfirmationModalActive"
			:preloader="deleteLoader"
			modal-id="demo-delete"
			@confirmed="confirmed"
			@cancelled="cancelled"
		/>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import { Schema } from "./Schema";
import { urlGenerator } from "../../../../../Helpers/AxiosHelper";
import {axiosPost} from "../../../../../Helpers/AxiosHelper";

export default {
	extends: CoreLibrary,
	name: "RegistrantListTable",
	mixins: [Schema],
	created() {
		this.options.columns = [...this.tableColumns, this.actionObj];
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#registration-list-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} if (actionObj.title == "Migration to leads") {
				this.openMigrationModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = `${this.Endpoint}/${rowData.id}`;
				this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},
		openMigrationModal() {
			this.migrationConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			let url = `${this.Endpoint}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},
		confirmedMigration() {
			let url = `${this.Endpoint}/${this.rowData.id}`;
			this.migrationLoader = true;
			axiosPost(url).then((response) => {
					this.migrationLoader = false;
					$("#demo-migration").modal("hide");
					this.cancelled();
					if(response.data.status == false){
						this.$toastr.e(response.data.message);
					}else{
						this.$toastr.s(response.data.message);
					}
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

                
		/** 
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		cancelledMigration() {
			this.migrationConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
	},
};
</script>
